import React from "react";
import NO_AVA from "styles/img/no-ava-card.png";
import classNames from "classnames";
import { Link } from "react-router-dom";

export default class ProviderItem extends React.Component {
  handleLogin = () => {
    console.log('sadsaas')
    const {user, handleProviderLogin} = this.props;
    handleProviderLogin(user.id);
  }

  render() {
    const {user} = this.props;
    return (
      <div className="col-12">
        <div
          className={classNames("card regular purchases")}
        >
          <div className="purchases-content">
            <div className="card-top-wrap">
              <div className="card-head-avatar-holder">
                <div className="card-head-avatar">
                  {user.avatar_url ? (
                    <img src={user.avatar_url} alt="avatar" />
                  ) : (
                      <img src={NO_AVA} alt="avatar" />
                    )}
                </div>
                <div className="card-head-name-holder">
                  <span className="card-head-title">PROVIDER</span>
                  <span className="card-head-name">
                    {`${user.first_name} ${user.last_name}`}
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className="purchases-price">
            <div onClick={this.handleLogin} className="btn prime bordered purchases-btn hide-s hide-xs">
              Login
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/providersList/ProviderItem.jsx